import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class SpinnerService {
  private spinnerSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private count: number = 0;
  public spinnerEnabled: boolean = true;

  show(): void {
    this.count++;
    if (this.count === 1) {
      this.updateSpinnerState();
    }
  }

  hide(): void {
    if (this.count > 0) {
      this.count--;
      if (this.count === 0) {
        this.updateSpinnerState();
      }
    }
  }

  private updateSpinnerState(): void {
    this.spinnerSubject.next(this.spinnerEnabled && this.count > 0);
  }

  getSpinnerState() {
    return this.spinnerSubject.asObservable();
  }
}
